<template>
  <div id="loginUser">
    <Form ref="formItem" :model="formItem" :label-width="80" class="user-form" :rules="formRule">
      <FormItem label="角色" prop="utype">
        <RadioGroup v-model="formItem.utype">
          <Radio label="createStudent">学生</Radio>
          <Radio label="createTeacher">老师</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="名字" prop="name">
        <Input v-model="formItem.name" placeholder="名字" :maxlength="10"/>
      </FormItem>
      <FormItem label="学校" prop="school">
        <Input v-model="formItem.school" placeholder="学校" :maxlength="50"/>
      </FormItem>
      <FormItem label="课程" prop="course" v-if="formItem.utype == 'createTeacher'">
        <Input v-model="formItem.course" placeholder="课程" :maxlength="30"/>
      </FormItem>
      <FormItem label="年级" prop="nianji" v-if="formItem.utype == 'createStudent'">
        <Input v-model="formItem.nianji" placeholder="年级" :maxlength="30"/>
      </FormItem>
      <FormItem label="班级" prop="banji" v-if="formItem.utype == 'createStudent'">
        <Input v-model="formItem.banji" placeholder="班级" :maxlength="10"/>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="signUp()">注册</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      formItem: {
        utype: 'createStudent',
        name: '',
        school: '',
        course: '',
        nianji: '',
        banji: ''
      },
      formRule: {
        utype: [
          {required: true, message: '请输入角色', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入名字', trigger: 'blur'}
        ],
        school: [
          {required: true, message: '请输入学校', trigger: 'blur'}
        ],
        course: [
          {required: true, message: '请选择课程', trigger: 'blur'}
        ],
        nianji: [
          {required: true, message: '请输入年级', trigger: 'blur'}
        ],
        banji: [
          {required: true, message: '请输入班级', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    signUp: function () {
      var vueThis = this
      vueThis.$refs['formItem'].validate((valid) => {
        if (valid) {
          let f = vueThis.formItem;
          let funcName = f.utype;
          let params = [f.name + '', f.school + '', f.course + ''];
          if (f.utype === 'createStudent') {
            params = [f.name + '', f.school + '', f.nianji + '', f.banji + ''];
          }
          vueThis.$Spin.show();
          vueThis.$store.dispatch('callNew', {funcName: funcName, params: params, goods: {name: '注册'}}).then((ret) => {
            vueThis.$Spin.hide();
            console.log('注册成功', ret);
            vueThis.showSuccess('注册成功, 3秒后自动刷新页面');
            _.delay(function () {
              vueThis.$router.push('/')
              location.reload();
            }, 3000)
          }, (error) => {
            console.log('注册失败', error);
            vueThis.$Spin.hide();
            vueThis.showErr('注册失败' + error);
          });
        } else {
          vueThis.showErr('请完善表单必填字段');
        }
      })
    }
  },
  computed: mapState([
    'user'
  ])
}
</script>

<style>
  #loginUser {
  }
</style>



// WEBPACK FOOTER //
// src/components/base-sign-up.vue